import { css } from "lit";

export const cohortsTabStyles = css`
  @import url("/src/styles/tokens.css");

  :host {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  henry-panel {
    flex: 1;
    min-height: 0;
  }

  .tab-body {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
  }

  .tab-scroll {
    flex: 1;
    min-height: 0;
    min-width: 0;
    overflow: auto;
  }

  .panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    flex-wrap: wrap;
  }

  .header-actions {
    display: flex;
    align-items: center;
    gap: var(--space-3);
  }

  .message {
    padding: var(--space-3) var(--space-4);
    border-radius: var(--radius-base);
    margin-bottom: var(--space-4);
    font-size: var(--font-size-sm);
    font-family: var(--font-family-base);
    display: flex;
    align-items: center;
  }

  .message.error {
    background-color: var(--color-danger-bg);
    border: 1px solid var(--color-danger);
    color: var(--color-danger-text);
  }

  .save-spinner {
    width: 16px;
    height: 16px;
    border: 2px solid var(--color-primary-600);
    border-top-color: transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  .form-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: var(--space-4);
    margin-bottom: var(--space-4);
  }

  henry-table {
    margin-top: 0;
  }

  .edit-input {
    padding: var(--space-1) var(--space-2);
    font-size: var(--font-size-sm);
  }

  .cohort-name-button {
    background: none;
    border: none;
    padding: 0;
    color: var(--color-primary-700);
    cursor: pointer;
    font: inherit;
    text-decoration: underline;
    text-decoration-color: var(--color-broken-black-30);
    text-underline-offset: 2px;
  }

  .cohort-name-button:hover {
    color: var(--color-primary-800);
    text-decoration-color: var(--color-broken-black-50);
  }

  .cohort-info-grid {
    display: grid;
    gap: var(--space-3);
    font-size: var(--font-size-sm);
    color: var(--color-text-primary);
  }

  .cohort-info-row {
    display: grid;
    grid-template-columns: minmax(120px, 160px) 1fr;
    gap: var(--space-3);
    align-items: start;
    text-align: left;
  }

  .cohort-info-label {
    font-size: var(--font-size-xs);
    color: var(--color-text-secondary);
    font-weight: var(--font-weight-semibold);
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .cohort-info-value {
    color: var(--color-text-primary);
    font-size: var(--font-size-sm);
    white-space: normal;
    word-break: break-word;
    line-height: 1.3;
  }

  .cohort-info-section {
    margin-top: var(--space-5);
    display: grid;
    gap: var(--space-3);
  }

  .cohort-info-section-title {
    font-size: var(--font-size-sm);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }

  .cohort-info-block {
    border: 1px solid var(--color-border);
    border-radius: var(--radius-md);
    padding: var(--space-3);
    background: var(--color-gray-50);
    display: grid;
    gap: var(--space-2);
    text-align: left;
  }

  .cohort-info-block-title {
    font-size: var(--font-size-xs);
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-secondary);
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }

  .cohort-info-empty {
    color: var(--color-text-secondary);
    font-size: var(--font-size-sm);
    text-align: left;
  }

  @media (max-width: 720px) {
    .cohort-info-row {
      grid-template-columns: 1fr;
    }
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
